import { ApiClient } from 'src/api/client/ApiClient'
import { apiOps } from 'src/api/defs/apiOps'
import { FranchisingContactRequest } from 'src/api/defs/FranchisingContactRequest.type'

export class FranchisingApi {
    constructor(private api: ApiClient) {}

    contactFranchising = (data: FranchisingContactRequest) =>
        this.api.do<FranchisingContactRequest>(apiOps.Franchising.contact, {
            data
        })
}
